export default function FaqHero() {
  return (
    <section className="relative pt-32 pb-20 md:pt-40 md:pb-28 overflow-hidden bg-[#1a1a1a]">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=modern%20commercial%20interior%20design%20studio%20workspace%20with%20warm%20lighting%2C%20architectural%20drawings%20and%20material%20samples%20on%20a%20minimal%20wooden%20desk%2C%20soft%20ambient%20light%2C%20neutral%20beige%20and%20warm%20tones%2C%20high-end%20professional%20atmosphere%2C%20no%20people%2C%20ultra%20clean%20aesthetic&width=1440&height=600&seq=faq-hero-bg&orientation=landscape"
          alt="FAQ背景"
          className="w-full h-full object-cover object-top opacity-30"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#1a1a1a]/60 via-[#1a1a1a]/50 to-[#1a1a1a]/80"></div>
      </div>

      <div className="relative max-w-[1440px] mx-auto px-6 md:px-10 w-full">
        <div className="max-w-2xl">
          <p className="text-[#b8956a] text-sm font-medium tracking-[0.25em] uppercase mb-5">
            FAQ · 常見問題
          </p>
          <h1 className="font-bold text-white leading-[1.25] mb-6" style={{ fontSize: 'clamp(2rem, 4.5vw, 3rem)' }}>
            開口問，才能<br />
            <span className="text-[#b8956a]">做出對的決定</span>
          </h1>
          <p className="text-white/70 leading-[1.8] mb-10" style={{ fontSize: 'clamp(1rem, 1.5vw, 1.125rem)' }}>
            我們整理了業主在評估、諮詢與合作過程中最常提出的問題，
            讓你在聯繫我們之前，對整個過程與費用已有清晰的認識。
          </p>

          {/* Quick stats */}
          <div className="flex flex-wrap gap-6">
            {[
              { num: '9', label: '大類問題' },
              { num: '免費', label: '初次諮詢' },
              { num: '24hr', label: '回覆承諾' },
            ].map((s) => (
              <div key={s.label} className="flex items-center gap-3">
                <span className="text-[#b8956a] font-bold" style={{ fontSize: '1.5rem' }}>{s.num}</span>
                <span className="text-white/50 text-sm border-l border-white/20 pl-3">{s.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
